function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2c61a5",
  d: "M11.134 11.232 6.207 9.857a8.695 8.695 0 0 0 .765 6.801l4.502-2.434a3.966 3.966 0 0 0 2.405 1.873l-1.438 4.815a9.334 9.334 0 0 0 6.974-.777L16.94 15.76a3.994 3.994 0 0 0 1.935-2.357l4.927 1.375a8.744 8.744 0 0 0-.765-6.801l-4.502 2.434a4.008 4.008 0 0 0-2.405-1.876l1.434-4.816a9.352 9.352 0 0 0-6.973.778l2.474 4.38a3.975 3.975 0 0 0-1.931 2.357Zm4.737-1.824a3.002 3.002 0 0 1 2.105 3.738 3.125 3.125 0 0 1-3.84 2.075 3.002 3.002 0 0 1-2.106-3.738 3.13 3.13 0 0 1 3.841-2.075Z",
  "data-name": "path-fan"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#212f46",
  d: "M17.152 12.502a2.118 2.118 0 1 1-2.118-2.118 2.119 2.119 0 0 1 2.118 2.118",
  "data-name": "Path 12069"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#212f46",
  d: "M29.351.001h-14.38a12.447 12.447 0 0 0-12.362 12.5 12.655 12.655 0 0 0 .924 4.741l-2.872-.031a.606.606 0 0 0-.468.191.65.65 0 0 0-.193.465v6.464a.656.656 0 0 0 .649.664h14.38a12.449 12.449 0 0 0 12.362-12.5 12.746 12.746 0 0 0-.92-4.744l2.868.031a.627.627 0 0 0 .468-.191.669.669 0 0 0 .193-.469V.662a.654.654 0 0 0-.649-.664Zm-3.324 12.5A11.025 11.025 0 1 1 15.015 1.325a11.132 11.132 0 0 1 11.012 11.177ZM1.308 23.675v-5.143l2.926.039a12.521 12.521 0 0 0 5.28 5.1ZM28.702 6.46l-2.93-.031a12.547 12.547 0 0 0-5.28-5.108h8.211Z",
  "data-name": "Path 12070"
});

var SvgNounWaterPump2734490 = function SvgNounWaterPump2734490(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24.996,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNounWaterPump2734490, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noun-water-pump-2734490.cc9eb4ed.svg";
export { ForwardRef as ReactComponent };